<template>
  <div class="" ref="sectionRef">
    <div class="md:px-10 max-w-screen-4xl mx-auto pb-10">
      <div class="bg-white px-10 shadow-lg py-10 w-full">
        <h2
          class="text-yellow text-center text-xl font-semibold tracking-wide py-6 uppercase -mt-14"
        >
          Our Value Proposition
        </h2>
        <hr
          class="h-0.5 bg-yellow mx-auto rounded-lg border-none -mt-4 transition-all duration-500 ease-in-out"
          :class="isActive ? 'w-60' : 'w-0'"
        />
        <div
          class="grid sm:grid-cols-1 md:grid-cols-2 lg:flex justify-center gap-6 md:gap-8 lg:gap-10 mt-14"
          ref="featureSection"
          v-motion="motionFadeUp"
        >
          <div
            class="bg-white shadow-lg rounded-2xl p-6 w-80 flex items-center gap-4 group transition-transform duration-300 hover:scale-105"
          >
            <svg
              class="w-10 h-10 mb-4 fill-gray-900 group-hover:fill-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 3c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
              />
            </svg>
            <h3
              class="text-xs text-gray-900 group-hover:text-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
            >
              Trust & Integrity
            </h3>
          </div>

          <div
            class="bg-white shadow-lg rounded-2xl p-6 w-80 flex items-center gap-4 group transition-transform duration-300 hover:scale-105"
          >
            <svg
              class="w-10 h-10 mb-4 fill-gray-900 group-hover:fill-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M12 2L6 9H10V21H14V9H18L12 2Z" />
            </svg>
            <h3
              class="text-xs text-gray-900 group-hover:text-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
            >
              Return on Investment <br />
              (ROI)
            </h3>
          </div>

          <div
            class="bg-white shadow-lg rounded-2xl p-6 w-80 flex items-center gap-4 group transition-transform duration-300 hover:scale-105"
          >
            <svg
              class="w-10 h-10 mb-4 fill-gray-900 group-hover:fill-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 3c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22zM15 12h-2v3h-2v-3H9V10h2V7h2v3h2v2z"
              />
            </svg>
            <h3
              class="text-xs text-gray-900 group-hover:text-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
            >
              Affordability
            </h3>
          </div>

          <div
            class="bg-white shadow-lg rounded-2xl p-6 w-80 flex items-center gap-4 group transition-transform duration-300 hover:scale-105"
          >
            <svg
              class="w-10 h-10 mb-4 fill-gray-900 group-hover:fill-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 3L2 8V17H6V21H18V17H22V8L12 3ZM12 10.5C13.657 10.5 15 11.843 15 13.5C15 15.157 13.657 16.5 12 16.5C10.343 16.5 9 15.157 9 13.5C9 11.843 10.343 10.5 12 10.5Z"
              />
            </svg>
            <h3
              class="text-xs text-gray-900 group-hover:text-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
            >
              Luxury Living
            </h3>
          </div>

          <div
            class="bg-white shadow-lg rounded-2xl p-6 w-80 flex items-center gap-4 group transition-transform duration-300 hover:scale-105"
          >
            <svg
              class="w-10 h-10 mb-4 fill-gray-900 group-hover:fill-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M16 11V13H8V11C8 9.89 8.9 9 10 9H14C15.1 9 16 9.89 16 11M15 16H9V18H15V16M12 3C10.89 3 10 3.89 10 5V7H14V5C14 3.89 13.1 3 12 3M19 19H5V8H19V19Z"
              />
            </svg>
            <h3
              class="text-xs text-gray-900 group-hover:text-[#e89e1c] transition-transform duration-300 hover:scale-105 cursor-pointer"
            >
              Land Banking
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const isActive = ref(false);
const sectionRef = ref(null);

const observer = new IntersectionObserver(
  ([entry]) => {
    isActive.value = entry.isIntersecting;
  },
  { threshold: 0.5 } // Adjust threshold based on when it should activate
);

onMounted(() => {
  if (sectionRef.value) observer.observe(sectionRef.value);
});

onUnmounted(() => {
  observer.disconnect();
});
</script>

<style scoped>
.story-style {
  font-family: "Caveat";
}
@keyframes underlineExpand {
  from {
    width: 0;
  }
  to {
    width: 15rem; /* Adjust to match the original 60 width */
  }
}

.animate-underline {
  animation: underlineExpand 1s ease-out forwards;
}
</style>
